import {
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_SUCCESS
} from '../constants'

const initialState = {
  deleteAccountState: {
    isLoading: false,
    error: null
  }
}

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ACCOUNT_REQUEST:
      return {
        deleteAccountState: {
          isLoading: true,
          error: null
        }
      }

    case DELETE_ACCOUNT_SUCCESS:
      return {
        deleteAccountState: {
          isLoading: false,
          error: null
        }
      }

    case DELETE_ACCOUNT_ERROR:
      return {
        deleteAccountState: {
          isLoading: false,
          error: action.payload
        }
      }

    default:
      return state
  }
}

export default UserReducer
